<div class=" d-none d-sm-block">

<div class="management-modern">
  <h2 class="management-heading">Meet Our Management</h2>
  <p class="management-intro">
    A team of visionaries committed to educational excellence, innovation, and integrity.
  </p>

  <div class="management-grid">
    <div class="manager-card">
      <h3>Chairperson</h3>
      <p>
        Leading with purpose and passion, our chairperson envisions a future where students thrive in a progressive, value-based environment.
      </p>
    </div>

    <div class="manager-card">
      <h3>Director</h3>
      <p>
        With a commitment to innovation and academic excellence, the director spearheads initiatives that inspire transformation.
      </p>
    </div>

    <div class="manager-card">
      <h3>Principal</h3>
      <p>
        At the core of the institution, our principal nurtures a culture of discipline, compassion, and high achievement.
      </p>
    </div>

    <div class="manager-card">
      <h3>Academic Head</h3>
      <p>
        Driving our academic strategies, the academic head ensures a curriculum that is both rigorous and engaging.
      </p>
    </div>
  </div>

  <button class="modern-contact-button" routerLink="/contact-us">
    Get in Touch
  </button>
</div>


  <br>


  <!-- HTML -->
<section class="school-management">
  <div class="school-management-container">
    <div class="school-management-text">
      <h2>Our Management</h2>
      <p>
        At <strong>PARASAKTHI CBSE SCHOOL</strong>, our leadership team is committed to fostering a vibrant learning
        environment that emphasizes both academic excellence and holistic development. With a vision rooted in values and
        future-readiness, our experienced educators and administrators guide every student toward success in a dynamic world.
      </p>
    </div>
    <div class="school-management-img">
      <img src="../../assets/img/about-us/schoolcampusaboutus.jpg" alt="School Management Team">
    </div>
  </div>
</section>

  <br>
<div style="
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  max-width: 900px;
  margin: 60px auto;
  font-family: 'Segoe UI', sans-serif;
">

  <!-- Left Side: Info -->
  <div style="
    background-color: #077A7D;
    color: white;
    padding: 40px 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  ">
    <h2 style="font-size: 28px; margin-bottom: 20px;">Get to Know Our School</h2>
    <p style="font-size: 16px; line-height: 1.6;">
      Learn more about our academic programs, admissions, student life, and world-class facilities. Discover how we help students thrive.
    </p>
  </div>

  <!-- Right Side: CTA -->
  <div style="
    background-color: white;
    padding: 40px 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-left: 4px solid #077A7D;
  ">
    <h4 style="color: #077A7D; margin-bottom: 16px;">Have Questions?</h4>
    <p style="margin-bottom: 24px; font-size: 15px; color: #333;">
      Our admissions team is here to help. Reach out to get personalized support and answers.
    </p>

    <a routerLink="/contact-us" routerLinkActive="active" style="text-decoration: none;">
      <button style="
        background-color: #077A7D;
        color: white;
        padding: 12px 28px;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.3s ease;
      " onmouseover="this.style.background='#055c5e'" onmouseout="this.style.background='#077A7D'">
        Contact Us&nbsp;<i class="fa fa-paper-plane"></i>
      </button>
    </a>
  </div>
</div>






  <br>
<section class="py-16 bg-gradient-to-b from-white to-gray-50">
  <div class="max-w-7xl mx-auto px-4">
    <h2 class="text-3xl font-bold text-center text-gray-800 mb-12">What Sets Us Apart</h2>
    <div class="flex flex-col md:flex-row gap-8 justify-center">
      <!-- Card 1 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-scale text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Core Values</h3>
        <p class="text-gray-600">
          Integrity, innovation, and inclusivity define our culture and guide our leadership ethos.
        </p>
      </div>

      <!-- Card 2 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-trending-up text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Strategic Goals</h3>
        <p class="text-gray-600">
          Shaping forward-thinking professionals to solve real-world challenges with agility.
        </p>
      </div>

      <!-- Card 3 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-briefcase text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Why Choose Us?</h3>
        <p class="text-gray-600">
          Global ties, expert mentors, and immersive industry experience fuel career transformations.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="student-info-clean">

  <div class="quote-section">
    <h2>Thought of the Day</h2>
    <p>"Education is the most powerful weapon which you can use to change the world." – Nelson Mandela</p>
  </div>

  <div class="rules-section">
    <h2>School Reminders</h2>
    <ul>
      <li>Be punctual and attend all classes regularly.</li>
      <li>Maintain discipline in and outside the classroom.</li>
      <li>Respect teachers, staff, and fellow students.</li>
    </ul>
  </div>

  <div class="wellness-section">
    <h2>Health & Wellness</h2>
    <p>Drink plenty of water and take short walks during study breaks to stay fresh.</p>
  </div>

  <div class="achievements-section">
    <h2>Monthly Highlights</h2>
    <p>Congratulations to the science team for winning the inter-school quiz competition!</p>
  </div>

  <div class="library-section">
    <h2>Library Corner</h2>
    <p>Library is open on all school days. New books arriving soon!</p>
  </div>
</section>

<div class="gallery-container p-4">
  <div *ngIf="links.length === 0" class="text-center text-gray-500">
    No Links available.
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div *ngFor="let link of links" class="image-item">
      <div class="image-wrapper border rounded-lg p-4 shadow text-center bg-white h-full">
        <i class="fas fa-file-alt text-4xl text-gray-600 mb-2"></i>
        <p class="text-lg font-semibold"><strong>Standard:</strong> {{ link.name }}</p>

        <a *ngIf="link.filePath" [href]="link.filePath" target="_blank"
          class="text-blue-600 underline hover:text-blue-800 break-words">
          <strong>Link:</strong> {{ link.filePath }}
        </a>
      </div>
    </div>
  </div>
</div>







  <br>
  <br>
  <div class="contact-info">
    <a href="tel:9894355288" class="contact-btn phone-btn">
      <span class="fa fa-phone"></span> Call Now
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="mailto:Info@sbconsultancy.org.in,mailto:sbconsultancytnj&#64;gmail.com" class="contact-btn email-btn">
      <span class="fa fa-envelope"></span> Email Us
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="https://wa.me/9894355288" target="_blank" class="contact-btn whatsapp-btn">
      <span class="fa fa-whatsapp"></span> WhatsApp
    </a>
  </div>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket" style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff;
   padding: 5px; color: #7AE2CF; border-radius: 50%;"></i>
  </div>

</div>






<!-- ---------------------------------MOBILE VIEW------------------------------------ -->
<div class=" d-block d-sm-none">


 <div class="management-modern">
  <h2 class="management-heading">Meet Our Management</h2>
  <p class="management-intro">
    A team of visionaries committed to educational excellence, innovation, and integrity.
  </p>

  <div class="management-grid">
    <div class="manager-card">
      <h3>Chairperson</h3>
      <p>
        Leading with purpose and passion, our chairperson envisions a future where students thrive in a progressive, value-based environment.
      </p>
    </div>

    <div class="manager-card">
      <h3>Director</h3>
      <p>
        With a commitment to innovation and academic excellence, the director spearheads initiatives that inspire transformation.
      </p>
    </div>

    <div class="manager-card">
      <h3>Principal</h3>
      <p>
        At the core of the institution, our principal nurtures a culture of discipline, compassion, and high achievement.
      </p>
    </div>

    <div class="manager-card">
      <h3>Academic Head</h3>
      <p>
        Driving our academic strategies, the academic head ensures a curriculum that is both rigorous and engaging.
      </p>
    </div>
  </div>

  <button class="modern-contact-button" routerLink="/contact-us">
    Get in Touch
  </button>
</div>


  <br>


  <!-- HTML -->
<section class="school-management">
  <div class="school-management-container">
    <div class="school-management-text">
      <h2>Our Management</h2>
      <p>
        At <strong>PARASAKTHI CBSE SCHOOL</strong>, our leadership team is committed to fostering a vibrant learning
        environment that emphasizes both academic excellence and holistic development. With a vision rooted in values and
        future-readiness, our experienced educators and administrators guide every student toward success in a dynamic world.
      </p>
    </div>
    <div class="school-management-img">
      <img src="../../assets/img/about-us/schoolcampusaboutus.jpg" alt="School Management Team">
    </div>
  </div>
</section>

  <br>
<div style="
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  max-width: 900px;
  margin: 60px auto;
  font-family: 'Segoe UI', sans-serif;
">

  <!-- Left Side: Info -->
  <div style="
    background-color: #077A7D;
    color: white;
    padding: 40px 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  ">
    <h2 style="font-size: 28px; margin-bottom: 20px;">Get to Know Our School</h2>
    <p style="font-size: 16px; line-height: 1.6;">
      Learn more about our academic programs, admissions, student life, and world-class facilities. Discover how we help students thrive.
    </p>
  </div>

  <!-- Right Side: CTA -->
  <div style="
    background-color: white;
    padding: 40px 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-left: 4px solid #077A7D;
  ">
    <h4 style="color: #077A7D; margin-bottom: 16px;">Have Questions?</h4>
    <p style="margin-bottom: 24px; font-size: 15px; color: #333;">
      Our admissions team is here to help. Reach out to get personalized support and answers.
    </p>

    <a routerLink="/contact-us" routerLinkActive="active" style="text-decoration: none;">
      <button style="
        background-color: #077A7D;
        color: white;
        padding: 12px 28px;
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.3s ease;
      " onmouseover="this.style.background='#055c5e'" onmouseout="this.style.background='#077A7D'">
        Contact Us&nbsp;<i class="fa fa-paper-plane"></i>
      </button>
    </a>
  </div>
</div>






  <br>
<section class="py-16 bg-gradient-to-b from-white to-gray-50">
  <div class="max-w-7xl mx-auto px-4">
    <h2 class="text-3xl font-bold text-center text-gray-800 mb-12">What Sets Us Apart</h2>
    <div class="flex flex-col md:flex-row gap-8 justify-center">
      <!-- Card 1 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-scale text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Core Values</h3>
        <p class="text-gray-600">
          Integrity, innovation, and inclusivity define our culture and guide our leadership ethos.
        </p>
      </div>

      <!-- Card 2 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-trending-up text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Strategic Goals</h3>
        <p class="text-gray-600">
          Shaping forward-thinking professionals to solve real-world challenges with agility.
        </p>
      </div>

      <!-- Card 3 -->
      <div class="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow p-8 text-center flex-1">
        <div class="mb-4 flex justify-center">
          <i class="lucide lucide-briefcase text-indigo-600 text-4xl"></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Why Choose Us?</h3>
        <p class="text-gray-600">
          Global ties, expert mentors, and immersive industry experience fuel career transformations.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="student-info-clean">

  <div class="quote-section">
    <h2>Thought of the Day</h2>
    <p>"Education is the most powerful weapon which you can use to change the world." – Nelson Mandela</p>
  </div>

  <div class="rules-section">
    <h2>School Reminders</h2>
    <ul>
      <li>Be punctual and attend all classes regularly.</li>
      <li>Maintain discipline in and outside the classroom.</li>
      <li>Respect teachers, staff, and fellow students.</li>
    </ul>
  </div>

  <div class="wellness-section">
    <h2>Health & Wellness</h2>
    <p>Drink plenty of water and take short walks during study breaks to stay fresh.</p>
  </div>

  <div class="achievements-section">
    <h2>Monthly Highlights</h2>
    <p>Congratulations to the science team for winning the inter-school quiz competition!</p>
  </div>

  <div class="library-section">
    <h2>Library Corner</h2>
    <p>Library is open on all school days. New books arriving soon!</p>
  </div>



</section>

<div class="gallery-container p-4">
  <div *ngIf="links.length === 0" class="text-center text-gray-500">
    No Links available.
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div *ngFor="let link of links" class="image-item">
      <div class="image-wrapper border rounded-lg p-4 shadow text-center bg-white h-full">
        <i class="fas fa-file-alt text-4xl text-gray-600 mb-2"></i>
        <p class="text-lg font-semibold"><strong>Standard:</strong> {{ link.name }}</p>

        <a *ngIf="link.filePath" [href]="link.filePath" target="_blank"
          class="text-blue-600 underline hover:text-blue-800 break-words">
          <strong>Link:</strong> {{ link.filePath }}
        </a>
      </div>
    </div>
  </div>
</div>



  <br>
  <br>
  <div class="contact-info">
    <a href="tel:9894355288" class="contact-btn phone-btn">
      <span class="fa fa-phone"></span> Call Now
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="mailto:Info@sbconsultancy.org.in,mailto:sbconsultancytnj&#64;gmail.com" class="contact-btn email-btn">
      <span class="fa fa-envelope"></span> Email Us
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="https://wa.me/9894355288" target="_blank" class="contact-btn whatsapp-btn">
      <span class="fa fa-whatsapp"></span> WhatsApp
    </a>
  </div>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket" style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff;
   padding: 5px; color: #7AE2CF; border-radius: 50%;"></i>
  </div>



</div>